    import React from 'react';
    import {
        Button,
        Col,
        Row,
        Input,
        Navbar,
        Nav,
        NavLink,
        CustomInput,
    } from 'reactstrap';
    import DatePicker from 'react-datepicker';
    import { faCalendar } from '@fortawesome/free-solid-svg-icons';
    import { connect } from "react-redux";
    import radioButton from '../../assets/radioButton.svg'
    import eyeIcon from '../../assets/eye.svg'
    import eyeIconhighlighted from '../../assets/eye-highlight.svg'
    import listIcon from '../../assets/list.svg'
    import listIconblue from '../../assets/list-blue.svg'
    import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'
    import {
        fetchFilterOptions,
        fetchBuilding,
        fetchFloors,
        fetchComplexTypes,
        fetchResultsList,
        fetchLocationResultsTrackingData
    } from '../../actions'
    import { NavLink as RRNavLink } from 'react-router-dom';
    import moment from 'moment';
    import MultiSelect from '@khanacademy/react-multi-select';
    import { toast, ToastContainer } from 'react-toastify';
    import "react-table/react-table.css";
    import "react-datepicker/dist/react-datepicker.css";
    import './trackResults.css'
    import ResultTracking from '../ResultTracking/resultTracking'
    import ResultTimeline from '../ResultTimeLine/resultTimeline'
    import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
    import { faInfoCircle} from '@fortawesome/free-solid-svg-icons';
    import NavBar from '../../components/NavBar/navBar'
    import Tour from '../../Tour';
    import { withAITracking } from '@microsoft/applicationinsights-react-js';
    import { reactPlugin, appInsights } from "../../AppInsights";
    import { SeverityLevel } from '@microsoft/applicationinsights-common';

    let errorDetails = ""
    let building=sessionStorage.getItem("building")
    let buildingId=sessionStorage.getItem("buildingId")
    let buildingName=sessionStorage.getItem("buildingName")
    let floor=sessionStorage.getItem("floor")
    let floorId=sessionStorage.getItem("floorId")
    let floorName=sessionStorage.getItem("floorName")
    const initialState = {
        resultBuilding:  building?building:"",
        resultFloor: floor?floor:"",
        fromDate: localStorage.getItem("guest")?new Date(2019, 6, 2):"",
        toDate: localStorage.getItem("guest")?new Date():"",
        resultOrganism: localStorage.getItem("guest")?"Salmonella":"",
        filterComplexList: [],
        buildingId:  buildingId?buildingId:"",
        floorId:  floorId?floorId:"",
        show: false,
        checkbox: true,
        isOpen: false,
        resultBatchNo: "",
        resultSampleType: "",
        Disable: localStorage.getItem("guest")?false:true,
        key: 1,
        alert:false,
        loader: false,
    }
    const colors = ['#f58026', '#0f61f5', '#00d168', '#7548c7', '#f53a1b']
    class TrackResults extends React.Component {
        constructor(props) {
            super(props)
            this.props.fetchFilterOptions()
            this.props.fetchBuilding()
            this.applyFilter = this.applyFilter.bind(this)
            this.toggle = this.toggle.bind(this);
            this.onChangeFromDate = this.onChangeFromDate.bind(this)
            this.onChangeToDate = this.onChangeToDate.bind(this)

            building=sessionStorage.getItem("building")
            buildingId=sessionStorage.getItem("buildingId")
            floor=sessionStorage.getItem("floor")
            floorId=sessionStorage.getItem("floorId")
            let floorInitialState = {
                resultBuilding: building?building:localStorage.getItem("guest")?"BldgA":"",
                resultFloor: floor?floor:localStorage.getItem("guest")?20000:"",
                floorId: floorId?floorId:localStorage.getItem("guest")?20000:"",
                buildingId: buildingId?buildingId:localStorage.getItem("guest")?20000:"",
                buildingName: buildingName?buildingName:localStorage.getItem("guest")?"Building A":"",
                floorName: floorName?floorName:localStorage.getItem("guest")?"Floor A":"",
            }
            this.initialState = this.props.initialState
            this.state = Object.assign(initialState, floorInitialState);
            if(localStorage.getItem("guest")){
            setTimeout(() => {
                this.getComplexTypes()
                let data = []
                this.props.complexList.complexList.forEach((item, index) =>{
                    if(this.props.complexList.complexList.length>5 && this.props.complexList.complexList.length-index<=5)
                        return data.push(item[0])
                    else if(this.props.complexList.complexList.length<=5) 
                        return data.push(item[0])
                })
                this.setState({filterComplexList: data, complexFilter: data})
                this.applyFilter()
            });
            }
        }


        ErrorDetails = () => {
            appInsights.trackTrace({message: errorDetails, properties:{page: "trackResults"}, severityLevel: SeverityLevel.Verbose})
            toast.error(errorDetails, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
            errorDetails = ""
            return true
        }

        handleOptionChange = (name, name2) => value => {
            if (value != null && value.length <= 5) {
                this.setState({
                    [name]: value,
                    [name2]: value,
                    alert: false
                });
            }
            else {
                if (value != null && value.length > 5) {
                    let message = "Please select atmost five CTs"
                    appInsights.trackException({ exception: new Error(message), name: 'Complex Type Selection', user: localStorage.getItem("userName"), severityLevel: SeverityLevel.Information })
                    this.setState({
                        alert: true
                    });
                    setTimeout(() => {this.setState({alert: false});}, 3000)
                }
            }
        }

        getfilters = (filterList) => {
            let arr = []
            let filter = filterList ? filterList['complexList'] : []
            if (filter) {
                filter.forEach((data) => {
                    arr.push({ value: data[0], label: `${data[0]}(${data[1]})` })
                })
            }
            return arr
        }

        handleFileChange({ target: { files } }) {
            if (files.length !== 0) {
                this.setState({
                    fileName: files[0].name,
                    pictureFile: files[0]
                })
            }
        }



    componentDidMount()
    {
        if(sessionStorage.getItem("building"))
        this.onSelectBuilding("",true)
    }
    onSelectBuilding = (event,flag=false) => {
        if(flag===false)
        {
        const {value,selectedOptions}=event.target
        sessionStorage.setItem("building",value)
        sessionStorage.setItem("buildingId",selectedOptions[0].id)
        sessionStorage.setItem("buildingName",selectedOptions[0].innerText)
        sessionStorage.setItem("floor","")
        sessionStorage.setItem("floorId","")
        sessionStorage.setItem("floorName","")
        }
            this.setState(prevState =>({
                ...this.state,
                resultBuilding:sessionStorage.getItem("building"),
                buildingId: sessionStorage.getItem("buildingId"),
                buildingName:sessionStorage.getItem("buildingName"),
                resultFloor: "",
                floorId:flag? prevState.floorId: "",
                floorName:flag? prevState.floorName: "",
                areas: flag? prevState.areas: [],
                floor_plan: flag? prevState.floor_plan: "",
                show: false,
                complexFilter: []
            }), async() => {
                await this.props.fetchFloors(this.state.buildingId)
                if(sessionStorage.getItem("floor"))
                await this.onSelectFloor("",true)
            })
        }

        onSelectFloor = (event,flag=false) => {
            if(flag===false)
            {
            const {value,selectedOptions}=event.target
            sessionStorage.setItem("floorName",selectedOptions[0].innerText)
            sessionStorage.setItem("floorId",selectedOptions[0].id)
            sessionStorage.setItem("floor",value)
            }       
            this.setState(prevState =>({
                ...this.state,
                resultFloor: sessionStorage.getItem("floor"),
                floorId:sessionStorage.getItem("floorId"),
                floorName:sessionStorage.getItem("floorName"),
                show: false,
                floor_plan: flag? prevState.floor_plan: "",
            }), () => {
                this.getComplexTypes()
            })
        }

        getComplexTypes = () => {
            if (this.state.resultFloor && this.state.resultBuilding
                && this.state.resultOrganism && this.state.fromDate && this.state.toDate) {
                this.setState({ Disable: false })
                var data = {
                    floor_id: this.state.resultFloor,
                    organism: this.state.resultOrganism,
                    from_date: moment.utc(new Date(this.state.fromDate)).format("YYYY-MM-DD"),
                    to_date: moment.utc(new Date(this.state.toDate)).format("YYYY-MM-DD")
                }
                if (this.state.resultBatchNo) {
                    data.batch_no = this.state.resultBatchNo
                }
                if (this.state.resultSampleType) {
                    data.type_of_sample = this.state.resultSampleType
                }
                this.props.fetchComplexTypes({ data })
            }
        }

        onSelectOrganism = (event) => {
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value,
                show: false,
                filterComplexList: [],
                complexFilter: []
            }, () => {
                this.getComplexTypes()
            })
        }

        onSelect = (event) => {
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value,
                show: false,
                filterComplexList: [],
                complexFilter: []
            }, () => {
                this.getComplexTypes()
            })
        }

        toggle(event) {
            this.setState({
                ctCheckboxMapping: {
                    ...this.state.ctCheckboxMapping,
                    [event.target.name]: !this.state.ctCheckboxMapping[event.target.name]
                },
                key: this.state.key + 1
            });
        }

        fetchLocationAreas = (data, ct_checkbox_mapping, ct_color_mapping) => {
            this.setState({loader: true})
            this.props.fetchLocationResultsTrackingData(data).then(response => {
                if (response.status === 200) {
                    if ("locations_data" in response.data) {
                        appInsights.trackTrace({message: 'Flooplan and Location Data is fetched successfully', properties:{page: "trackResults", name: response.data.locations_data.floor_data.floor_name, id: this.state.floorId, organism: this.state.resultOrganism, complexType: this.state.complexFilter}, severityLevel: SeverityLevel.Information});
                        this.setState({
                            resultsData: response.data.locations_data,
                            complexTypeFilter: this.state.complexFilter,
                            key: this.state.key + 1,
                            show: true,
                            loader: false,
                            ctColorMapping: ct_color_mapping,
                            ctCheckboxMapping: ct_checkbox_mapping
                        })
                    }
                }
                else {
                    this.setState({loader: false})
                    let message = "Errors in loading locations data!"
                    appInsights.trackTrace({message: message, properties:{page: "trackResults", name: this.state.floorName, id: this.state.floorId, organism: this.state.resultOrganism, complexType: this.state.complexFilter}, severityLevel: SeverityLevel.Error});
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch((error) => {
                this.setState({loader: false})
                let message = "Errors in loading locations data!"
                appInsights.trackTrace({message: message, properties:{page: "trackResults", name: this.state.floorName, id: this.state.floorId, organism: this.state.resultOrganism, complexType: this.state.complexFilter, error: error}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }

        fetchResultsData = (data, ct_checkbox_mapping, ct_color_mapping) => {
            // let date = moment(new Date(this.state.datetime)).format('YYYY-MM-DD')
            // let from_date = moment(new Date(this.state.datetime) -4 ).format('YYYY-MM-DD')
            this.props.fetchResultsList(data, true).then(response => {
                if (response.status === 200) {
                    appInsights.trackTrace({message: 'Results Data is fetched successfully', properties:{page: "trackResults", name: this.state.floorName, id: this.state.floorId, organism: this.state.resultOrganism, complexType: this.state.complexFilter}, severityLevel: SeverityLevel.Information});
                    this.setState({
                        resultsTimelineData: response.data,
                        complexTypeFilter: this.state.complexFilter,
                        key: this.state.key + 1,
                        show: true,
                        ctColorMapping: ct_color_mapping,
                        ctCheckboxMapping: ct_checkbox_mapping
                    })
                }
                else {
                    let message = "Errors in loading results data!"
                    appInsights.trackTrace({message: message, properties:{page: "trackResults", name: this.state.floorName, id: this.state.floorId, organism: this.state.resultOrganism, complexType: this.state.complexFilter}, severityLevel: SeverityLevel.Error});
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch((error) => {
                let message = "Errors in loading results data!"
                appInsights.trackTrace({message: message, properties:{page: "trackResults", name: this.state.floorName, id: this.state.floorId, organism: this.state.resultOrganism, complexType: this.state.complexFilter, error: error}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }

        applyFilter = () => {
            if (this.isvalidData(this.state)) {
                var data = {
                    type_of_samples: this.state.resultSampleType,
                    // type_of_analysis: this.state.analysisFilter ? this.state.analysisFilter.toString() : "",
                    organism: this.state.resultOrganism,
                    date_time_after: moment.utc(new Date(this.state.fromDate)).format("YYYY-MM-DD"),
                    date_time_before: moment.utc(new Date(this.state.toDate)).format("YYYY-MM-DD"),
                    // location: this.state.locationFilter ? this.state.locationFilter.toString() : "",
                    batch_no: this.state.resultBatchNo,
                    building: this.state.buildingId,
                    complex_type: this.state.complexFilter ? this.state.complexFilter.toString() : ""
                }
                let ct_color_mapping = {};
                let ct_checkbox_mapping = {}
                this.state.complexFilter.forEach((ct, i) => { ct_color_mapping[ct] = colors[i]; ct_checkbox_mapping[ct] = true });
                // this.state.complexFilter.forEach((ct, i) => { ct_color_mapping[ct] = colors[i] });

                if (!this.state.showTimeline) {
                    data.floor__id = this.state.floorId
                    this.fetchLocationAreas(data, ct_checkbox_mapping, ct_color_mapping)
                }
                else {
                    data.floor = this.state.floorId
                    this.fetchResultsData(data, ct_checkbox_mapping, ct_color_mapping)
                }
            }
            else {
                this.ErrorDetails()
                this.setState({
                    resultsData: [],
                    resultsTimelineData: []
                })
            }
        }

        isvalidData = (data) => {
            let isValidToDate = moment(data.toDate).isValid()
            let isValidFromDate = moment(data.fromDate).isValid()
            let CTlength = data.complexFilter ? data.complexFilter.length : 0
            if (data.buildingId && data.floorId && isValidToDate && isValidFromDate && CTlength > 0 && CTlength <= 5 && data.resultOrganism && (data.fromDate.setHours(0,0,0,0) <= data.toDate.setHours(0,0,0,0))) {
                return true
            }
            else if (!data.buildingId) {
                errorDetails = "Please select a Building!"
                // this.resetData()
                return false
            }
            else if (!data.floorId) {
                errorDetails = "Please select a Floor!"
                // this.resetData()
                return false
            }
            else if (!isValidFromDate ||  !(data.fromDate.setHours(0,0,0,0) <= data.toDate.setHours(0,0,0,0))) {
                errorDetails = "Plaese select proper From Date!"
                // this.resetData()
                return false
            }
            else if (!isValidToDate) {
                errorDetails = "Please select proper To Date!"
                // this.resetData()
                return false
            }
            else if (!data.resultOrganism) {
                errorDetails = "Please select an Organism!"
                // this.resetData()
                return false
            }
            else if (CTlength <= 0) {
                errorDetails = "Please select atleast one CT"
                // this.resetData()
                return false
            }
            else if (CTlength > 5) {
                errorDetails = "Please select atmost five CTs"
                // this.resetData()
                return false
            }

        }

        getDatetime = date => {
            let datetime = new Date()

            datetime.setDate(date.getDate());
            datetime.setMonth(date.getMonth());
            datetime.setFullYear(date.getFullYear());

            return datetime
        }


        onChangeFromDate = (date) => {

            this.setState({
                fromDate: this.getDatetime(date),
                show: false,
                filterComplexList: [],
                complexFilter: []
            }, () => {
                this.getComplexTypes()
            })
        }

        onChangeToDate = (date) => {
            this.setState({
                toDate: this.getDatetime(date),
                show: false,
                filterComplexList: [],
                complexFilter: []
            }, () => {
                this.getComplexTypes()
            })
        }

        handleValueChange = (event) => {
            this.setState({
                ...this.state,
                [event.target.name]: event.currentTarget.value
            })
        }

        checkBox = () => {
            this.setState(prevState => ({
                checkbox: !prevState.checkbox,
            }))
        }

        resetData = () => {
            this.setState({
                ...initialState,
                organismFilter: [],
                complexFilter: [],
                isOpen: this.state.isOpen,
                resultsData: [],
                resultsTimelineData: []
            }, () => {
                if(localStorage.getItem("guest"))
                    this.getComplexTypes()
            })            
        }

        clickedTimelineView = () => {
            if (this.state.show) {
                this.setState({
                    showTimeline: true
                }, () => this.applyFilter())
            }
            else {
                this.setState({
                    showTimeline: true
                })
            }
        }


        clickedFloorView = () => {
            if (this.state.show) {
                this.setState({
                    showTimeline: false
                }, () => this.applyFilter())
            }
            else {
                this.setState({
                    showTimeline: false
                })
            }
        }


        render() {
            return (
                <div data-tut="reactour__results" className="page-layout">
                    <NavBar />
                    <div className='dashboard-overview samples-page results-page'>
                        <div className="dashboard-content-25" ref={(divElement) => { this.divElement = divElement }}>
                            <Row className="sample-list-header" form>
                                <Navbar className="navbar-results " light expand="md">
                                    <Nav navbar data-tut="reactour__nav">
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/viewresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>All Results</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link bottom-border" activeClassName="active" to="/results/trackresults/"><span className="nav-col"><img src={radioButtonhighlighted} className="nav-icons" alt=''/>Track Species</span></NavLink>
                                        <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/speciesresults/"><span className="nav-col"><img src={radioButton} className="nav-icons" alt=''/>Species Density</span></NavLink>      
                                    </Nav>
                                </Navbar>
                            </Row>
                            <div className='sample-input-area' data-tut="reactour__apply">
                                <Row form>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className={this.state.resultBuilding? this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} id="trackBuilding" type="select" name="resultBuilding" value={this.state.resultBuilding} onChange={this.onSelectBuilding} size="1">
                                            <option value="" default disabled>Region*</option>
                                            {this.props.buildingList.map((building, key) => {
                                                return <option className="dashboard-options" id={building.id} key={key} value={building.building_id}>{building.building_name}</option>
                                            })}
                                        </Input>
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className={this.state.resultFloor? this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} id="trackFloor" type="select" name="resultFloor" value={this.state.resultFloor} onChange={this.onSelectFloor} size="1">
                                            <option value="" default disabled>Map*</option>
                                            {this.props.floorsList.map((floor, key) => {
                                                return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                            })}
                                        </Input>
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <div>
                                        <DatePicker
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            portalId='root'
                                            popperProps={{
                                                positionFixed: true
                                            }}
                                            id="from-date"
                                            selected={this.state.fromDate}
                                            onChange={this.onChangeFromDate}
                                            filterDate={(date) => {
                                                return moment() > date;
                                            }}
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="From*"
                                            autoComplete='off'
                                            popperModifiers={{
                                                preventOverflow: {
                                                  enabled: true,
                                                },
                                              }}
                                        />
                                        </div>
                                    {window.innerWidth>1500 &&<FontAwesomeIcon className='date-icon-results' icon={faCalendar} size="lg" />}
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <div>
                                        <DatePicker
                                            className="sample-input-fields form-control"
                                            wrapperClassName="datepicker-wrapper"
                                            popperProps={{
                                                positionFixed: true
                                            }}
                                            portalId='root'
                                            id="to-date"
                                            selected={this.state.toDate}
                                            onChange={this.onChangeToDate}
                                            filterDate={(date) => {
                                                return moment() > date;
                                            }}
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="MMMM d, yyyy"
                                            dateFormatCalendar=" "
                                            placeholderText="To*"
                                            autoComplete='off'
                                            popperModifiers={{
                                                preventOverflow: {
                                                  enabled: true,
                                                },
                                              }}
                                        />
                                        </div>
                                    {window.innerWidth>1500 &&<FontAwesomeIcon className='date-icon-results' icon={faCalendar} size="lg" />}
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <MultiSelect
                                            className={this.state.filterComplexList?"sample-input-fields complex-type-input":"sample-input-fields default-disabled complex-type-input"}
                                            options={this.getfilters(this.props.complexList)}
                                            selected={this.state.filterComplexList}
                                            onSelectedChanged={this.handleOptionChange('complexFilter', 'filterComplexList')}
                                            overrideStrings={{
                                                selectSomeItems: "Species*",
                                                allItemsAreSelected: "All species are Selected",
                                            }}
                                            id="complexFilter"
                                            disabled={this.state.Disable}
                                        />
                                        {this.state.alert ?
                                            <div class="popup" >
                                                <FontAwesomeIcon icon={faInfoCircle} />
                                                <span class="popup-text" id="myPopup">You cannot select more than 5 species types!</span>
                                            </div>
                                            : null
                                        }
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className={this.state.resultBatchNo? this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultBatchNo" value={this.state.resultBatchNo} onChange={this.onSelect} size="1">
                                            <option value="" default >Batch Number</option>
                                            {this.props.filters.batchNoList ? this.props.filters.batchNoList.map((batch, key) => {
                                                return <option className="dashboard-options" id={batch} key={key} value={batch}>{batch}</option>
                                            }) : null}
                                        </Input>
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className={this.state.resultSampleType? this.props.sideBarHover?  "sample-input-fields no-display": "sample-input-fields": this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="resultSampleType" value={this.state.resultSampleType} onChange={this.onSelect} size="1">
                                            <option value="" default >Type of Sample</option>
                                            {this.props.filters.typeOfSamplesList ? this.props.filters.typeOfSamplesList.map((sample, key) => {
                                                return <option className="dashboard-options" id={sample} key={key} value={sample}>{sample}</option>
                                            }) : null}
                                        </Input>
                                    </Col>
                                    <Col className="clear-apply-end" data-tut="reactour__apply">
                                        <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                        <Button id="applyFloorButton" type="submit" onClick={this.applyFilter}>Apply</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    <div className="grid-data width" data-tut="reactour__resultView">
                        <div>
                            {this.state.show ?
                                <div>
                                    <Row className="sample-list-header" form>
                                            <Col style={{ textAlign: "start" }}>
                                                <Navbar className="navbar-results" light expand="md">
                                                    <Nav navbar data-tut="reactour__nav">
                                                    {this.state.showTimeline ?
                                                    <>
                                                    <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="" to="/results/trackresults/" onClick={this.clickedFloorView}><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt=''/>Map view</span></NavLink>
                                                    <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/trackresults/" onClick={this.clickedTimelineView}><span className="nav-col"><img src={listIcon} className="nav-icons" alt=''/>Timeline view</span></NavLink>
                                                    </>
                                                    :
                                                    <>
                                                    <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/trackresults/" onClick={this.clickedFloorView}><span className="nav-col"><img src={eyeIconhighlighted} className="nav-icons" alt=''/>Map view</span></NavLink>
                                                    <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="" to="/results/trackresults/" onClick={this.clickedTimelineView}><span className="nav-col"><img src={listIconblue} className="nav-icons" alt=''/>Timeline view</span></NavLink>
                                                    </>
                                                    }
                                                    </Nav>
                                                </Navbar>
                                            </Col>
                                        </Row>
                                    <div className={!this.state.showTimeline ? "d-flex flex-row-forward ct-data" : "d-flex flex-row-forward timeline-ct-data"}>
                                        {this.state.ctColorMapping ? Object.entries(this.state.ctColorMapping).map(([complex, color]) => {
                                            return (
                                                <CustomInput checked={this.state.ctCheckboxMapping[complex]} className={"ct-checkbox height-level a" + color.split('#')[1]} type="checkbox" id={complex} name={complex} style={{ margin: '5px', color: color }} onChange={this.toggle} label={complex} />)
                                        }) : null}
                                    </div>
                                    {this.state.resultsData !== undefined && this.state.resultsData.data && this.state.resultsData.data.length > 0 && !this.state.showTimeline ?
                                        <ResultTracking resultsData={this.state.resultsData} ctColorMapping={this.state.ctColorMapping} ctCheckboxMapping={this.state.ctCheckboxMapping} key={this.state.key}></ResultTracking>
                                        : null
                                    }
                                    {this.state.resultsTimelineData !== undefined && this.state.resultsTimelineData.length > 0 && this.state.showTimeline ?
                                        <ResultTimeline resultsData={this.state.resultsTimelineData} ctColorMapping={this.state.ctColorMapping} ctCheckboxMapping={this.state.ctCheckboxMapping} key={this.state.key} min={this.state.fromDate} max={this.state.toDate}></ResultTimeline>
                                        : null
                                    }
                                </div>
                                :
                                <>
                                <Row className="sample-list-header" form>
                                    <Navbar className="navbar-results" light expand="md">
                                        <Nav navbar data-tut="reactour__nav" >
                                        {!this.state.showTimeline ?
                                            <>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/trackresults/" onClick={this.clickedFloorView}><span className="nav-col"><img src={eyeIconhighlighted} style={{paddingRight: "7px", paddingBottom: "3px"}} alt=''/>Map View</span></NavLink>
                                            </>
                                            :
                                            <>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="" to="/results/trackresults/" onClick={this.clickedFloorView}><span className="nav-col"><img src={eyeIcon} style={{paddingRight: "7px", paddingBottom: "3px"}} alt=''/>Map View</span></NavLink>
                                            </>
                                        }
                                        </Nav>
                                    </Navbar>
                                        <Navbar className="navbar-results" light expand="md">
                                        <Nav navbar data-tut="reactour__nav">
                                        {this.state.showTimeline ?
                                            <>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/results/trackresults/" onClick={this.clickedTimelineView}><span className="nav-col"><img src={listIcon} style={{paddingRight: "7px", paddingBottom: "3px"}} alt=''/>Timeline View</span></NavLink>
                                            </>
                                            :
                                            <>
                                            <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="" to="/results/trackresults/" onClick={this.clickedTimelineView}><span className="nav-col"><img src={listIconblue} style={{paddingRight: "7px", paddingBottom: "3px"}} alt=''/>Timeline View</span></NavLink>
                                            </>
                                        }
                                        </Nav>
                                    </Navbar>
                                </Row>
                                <div className="no-data-msg results-data">Select above criteria and click on Apply button to view data. </div>
                                </>
                            }
                        </div>
                    </div>
                    </div>
                    <ToastContainer autoClose={3000} />
                    {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
                </div>
            )
        }
    }

    const mapStateToProps = state => {

        return {
            filters: state.results_data.filters,
            locationList: state.sample_data.locationList,
            buildingList: state.floor_data.buildingsList,
            floorsList: state.floor_data.floorsList,
            initialState: state.results_data.initialState,
            complexList: state.results_data.complexList
        }
    }

    export default withAITracking(reactPlugin, connect(
        mapStateToProps,
        {
            fetchFilterOptions,
            fetchBuilding,
            fetchFloors,
            fetchComplexTypes,
            fetchResultsList,
            fetchLocationResultsTrackingData
        }
    )(TrackResults), 'Track Results', 'TrackResults');